<template>
  <div>
    <v-card v-if="!office">
      <WBDStatementPageFilter
        :statement-page-filter="statementPageFilter"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="getModelList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="getPaginator.total"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.checkedAt="{ item }">
        {{ item.checkedAt ? appFormatDateTime(item.checkedAt) : null }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          text
          x-small
          color="info"
          title="Обновить дерево отсюда"
          @click="onRestoreTree(item)"
          :disabled="!item.restoreEnabled"
        >
          <v-icon>mdi-cog-refresh-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import ApiMixin from '@/mixins/api-mixin'
import { pluriaizeRows } from '@/utils/plural-util'
import { formatDateTime } from '@/utils/dateUtl'
import WBDStatementPageFilter from '@/components/common/filter/page-statement-filter'

export default {
  name: 'WBDStatementListPage',
  components: { WBDStatementPageFilter },
  mixins: [ListMixin, ApiMixin],
  props: {
    discr: {
      type: String
    },
    office: {
      type: Object
    },
    lite: {
      type: Object
    }
  },
  data: () => ({
    modelList: [],
    editable: false,
    loading: true,
    pagination: 0,
    selectedCity: null,
    editModalShowMode: false,
    statementPageFilter: {
      office: null,
    },
    options: {},
    headers: [
      {
        text: 'Дата',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Старый баланса',
        align: 'left',
        sortable: false,
        value: 'prev',
      },
      {
        text: 'Кол-во',
        align: 'left',
        sortable: false,
        value: 'balance',
      },
      {
        text: 'Остаток на балансе',
        align: 'left',
        value: 'next',
        sortable: false,
      },
      {
        text: 'Событие.',
        align: 'left',
        value: 'eventTrans',
        sortable: false,
      },
      {
        text: 'Объект.',
        align: 'left',
        value: 'office.title',
        sortable: false,
      },
      {
        text: 'Номер оффера/МТО',
        align: 'left',
        value: 'supportNumber',
        sortable: false,
      },
      {
        text: 'Номер логгера',
        align: 'left',
        value: 'loggerNum',
        sortable: false,
      },
      {
        text: 'Проверено',
        align: 'left',
        value: 'checkedAt',
        sortable: false,
      },
      // {
      //   text: 'причина.',
      //   align: 'left',
      //   value: 'resourceId',
      //   sortable: false,
      // },
      { text: '', value: 'options' },
    ],

  }),
  computed: {
    searchResultLabel () {
      return `Найдено: ${this.pagination} ${pluriaizeRows(this.pagination)}`
    },
    getActiveFilterNumber () {
      const params = {
        ...this.statementPageFilter
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
    getList () {
      return this.modelList
    },
    getPaginator () {
      return { total: this.pagination }
    }
  },
  watch: {
    options: {
      handler () {
        this.getModelList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async created () {
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
      sortBy: ['supportNumber'],
      sortDesc: ['DESC'],
    }

    if (this.office) {
      this.statementPageFilter.office = this.office
    }
  },
  methods: {
    async resetFilterSet () {
      const hasFilter = this.getActiveFilterNumber
      this.statementPageFilter = {
        searchQuery: null,
        region: null,
      }

      this.eventsBus.$emit(this.eventNames.PAGE_STATEMENT_RESET)

      if (hasFilter > 0) {
        await this.getModelList(1, this.options.itemsPerPage)
      }
    },
    async getModelList (page, size) {
      this.modelList = []
      const params = { 'page[number]': page, 'page[size]': size }
      if (this.discr) {
        params.discr = this.discr
      }
      const { sortBy, sortDesc } = this.options


      // "id" => $object->getId(),
      //     "balance" => $object->getBalance(),
      //     "createdAt" => $object->getCreatedAt()->format(\DATE_ATOM),
      // "office" => $officeData,
      //     "organization" => $organizationData,
      //     "event" => $object->getEvent(),
      //     "eventTrans" => InstitutionBalanceRefillEvent::translateOfferEvent($object->getEvent()),
      //     "resourceId" => $object->getResourceId(),
      //

      if (sortBy && sortBy.length) {
        for (const [index, item] of sortBy.entries()) {
          let propName = null
          switch (item) {
          case 'dateString':
            propName = 'createdAt'
            break
          case 'prev':
            propName = 'prevBalance'
            break
          case 'next':
            propName = 'nextBalance'
            break
          case 'balance':
            propName = 'balance'
            break
          case 'eventTrans':
            propName = 'event'
            break
          case 'office.title':
            propName = 'office.title'
            break
          }

          if (propName) {
            params[`ordering[${propName}]`] = sortDesc[index] ? 'DESC' : 'ASC'
          }
        }
      }

      const { office } = this.statementPageFilter

      if (office) {
        params['office[id]'] = office.id
      }

      try {
        this.loading = true
        await this.requestOfferBalanceStatement(this.mapModelListData, params)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    mapModelListData (modelListData) {
      if (modelListData && modelListData.error) {
        this.modelList = []
      } else {
        this.modelList = modelListData.modelList.map((item) => ({
          ...item,
          dateString: formatDateTime(item.createdAt, 'DD MMMM YYYY')
        }))
        this.pagination = modelListData.total || 0
      }
    },
    async onRestoreTree (item) {
      const confirmation = window.confirm('Вы подтверждаете обновление дерева?')
      if (confirmation) {
        await this.restoreTree(item)
      }
    },
    async restoreTree (item) {
      try {
        this.showPageLoader()
        await this.$store.dispatch(
            'organization/restoreOfferBalanceStatement',
            {id: item.id}
        )
        await this.getModelList(1, this.options.itemsPerPage)
        this.showSuccessNotification('Дерево успешно обновлено')
      } catch (error) {
        console.log(error)
        this.showErrorNotification('Ошибка при обновлении Дерева')
      } finally {
        this.hidePageLoader()
      }
    },
  },
}
</script>
